/**
 * @fileoverview POST handler for the "/engagement/canvas/restore_canvas_retargeting_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasRestoreCanvasRetargetingDataCacheKeys } from "./constants";
import type {
  EngagementCanvasRestoreCanvasRetargetingDataResult,
  PostEngagementCanvasRestoreCanvasRetargetingDataProps,
} from "./types";

export const postEngagementCanvasRestoreCanvasRetargetingData = reactQueryMutationAdapter(
  engagementCanvasRestoreCanvasRetargetingDataCacheKeys,
  (
    props: PostEngagementCanvasRestoreCanvasRetargetingDataProps
  ): Promise<EngagementCanvasRestoreCanvasRetargetingDataResult> => {
    return fetch("/engagement/canvas/restore_canvas_retargeting_data", "POST", props);
  }
);
